<template>
  <canvas
    ref="canvas"
    @click="addFocalpoint"
  ></canvas>
</template>

<script>
import { head, tail, throttle } from 'lodash'

export default {
  props: [
    'polygones',
    'focalpoints',
    'image'
  ],
  computed: {
    canvas() {
      return this.$refs.canvas
    },
    context() {
      return this.canvas.getContext('2d')
    }
  },
  methods: {
    addFocalpoint(e) {
      const rect = this.canvas.getBoundingClientRect()
      const cx = e.clientX - rect.left
      const cy = e.clientY - rect.top

      const dx = this.image.naturalWidth / this.canvas.width
      const dy = this.image.naturalHeight / this.canvas.height

      const x = cx * dx
      const y = cy * dy

      this.$emit('addFocalpoint', {
        x, y,
        radius: 30,
      })
    },

    drawPolygones(data) {
      data.forEach(item => {
        const { color } = item

        var dx, dy;

        // check if image is rotated and alter dx,dy correpondently
        if (this.image.naturalWidth > this.image.naturalHeight && this.canvas.width > this.canvas.height){
          dx = this.image.naturalWidth / this.canvas.width
          dy = this.image.naturalHeight / this.canvas.height

        }
        else if (this.image.naturalWidth < this.image.naturalHeight && this.canvas.width < this.canvas.height){
          dx = this.image.naturalWidth / this.canvas.width
          dy = this.image.naturalHeight / this.canvas.height
        }
        else {
          // image is rotated.
          dx = this.image.naturalHeight / this.canvas.width
          dy = this.image.naturalWidth / this.canvas.height
        }


        const coords = item.coords.map(({ x, y }) => ({ x: x / dx, y: y / dy }))

        this.context.lineWidth = 2
        this.context.fillStyle = color
        this.context.strokeStyle = '#00ff00' // color of polygon line
        const coordsHead = head(coords)
        const coordsTail = tail(coords)

        this.context.beginPath()
        this.context.moveTo(coordsHead.x, coordsHead.y)

        coordsTail.forEach(({ x, y }) => this.context.lineTo(x,y))
        this.context.closePath()

        this.context.stroke()
      })

      this.drawText(data.filter(item => item.text))
    },

    drawText(data) {
      data.forEach((item) => {
        const { color, text } = item
        const dx = this.image.naturalWidth / this.canvas.width
        const dy = this.image.naturalHeight / this.canvas.height

        const coords = item.coords
          ? item.coords.map(({ x, y }) => ({ x: x / dx, y: y / dy }))
          : [{ x: item.x / dx, y: item.y / dy }]

        const coordsHead = head(coords)
        this.context.lineWidth = 1
        this.context.fillStyle = '#fff' //color
        this.context.strokeStyle = color
        this.context.font = '16px Arial'
        this.context.fillText(text, coordsHead.x, coordsHead.y)
      })
    },

    drawFocalpoints(data) {
      data.forEach((item) => {
        const { x, y, radius } = item
        const dx = this.image.naturalWidth / this.canvas.width
        const dy = this.image.naturalHeight / this.canvas.height

        this.context.strokeStyle = item.color || 'rgba(219, 255, 173, .7)'
        this.context.lineWidth = 5

        this.context.beginPath()
        this.context.arc(x / dx, y / dy, radius, 0, 2 * Math.PI, false)
        this.context.stroke()
      })

      this.drawText(data.filter(item => item.text))
    },

    clear() {
      this.context.clearRect(
        0, 0,
        this.canvas.width, this.canvas.height
      )
    },

    render() {
      if (!this.canvas) { return }
      this.clear()

      this.drawPolygones(this.polygones || [])
      this.drawFocalpoints(this.focalpoints || [])
    },

    init: throttle(function () {
      this.canvas.height = this.canvas.offsetHeight
      this.canvas.width = this.canvas.offsetWidth
      this.render()
    }, 50)
  },
  mounted() {
    this.init()
    window.addEventListener('resize', this.init)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.init)
  },
  watch: {
    polygones() {
      this.render()
    },
    focalpoints() {
      this.render()
    }
  }
}
</script>
